export default __webpack_public_path__ + "images/highlight_link.1efb755.svg";